import { suburbs } from "./suburbs.position";

export const suburbCodesWithImage = suburbs.map((suburb) => suburb.code);
